import {
  deleteGroupWithId,
  getMemberInfo,
  removeParticipantOfGroup,
  validateSecurityQuestionsAPI,
  validatePassphraseAPI,
  getApplicationKeyPair,
  authorizeMemberAPI,
  createSecurityQuestions,
  createPassphrase,
  completeReauthenticationWithPassphraseOrSQ,
  changePasscodeImpl,
  // getMemberPublicKeyImpl,
  getGroupById,
  // getGroupByName,
  removeParticipantsOfGroup,
  removeParticipantsFromGroupExceptList,
  registerDeveloperAccount,
  loginDeveloperAccount,
  getTwoFAData,
  loginWithAppCredentials,
  loginViaValidatePasscode,
  getMemberClientData,
  getMemberLockBox,
  prepareSetSecurityQuestionsRequest,
  buildUserValidationSecret,
  getUserValidationSecretFromStorage,
  decryptAndGetUserPrivateKey,
  getAuthAnswerHashes,
  prepareSetNewPassphraseRequest,
  updateUserRecoveryFlow,
} from "./rest/BayunAPIManager";
import {
  addNewParticipantsToGroup,
  addNewParticipantToGroup,
  createNewGroup,
  getJoinedGroups,
  getUnjoinedGroupsForMember,
  joinNewPublicGroup,
  leaveGroupById,
} from "./rest/BayunGroupManager";
import ErrorConstants from "./constants/BayunError";
import {
  exportEccPrivateKey,
  exportEccPublicKey,
  generateEccKeyPair,
  generateEccSigningKeyPair,
} from "./crypto/EccEncryption";
import {
  getEncryptionKey,
  getEncryptionKeyAsString,
} from "./manager/CryptManager";
import {
  // generateRandomUuid,
  getFromStorage,
  initAuthenticationProcess,
  finalizeSignedInSession,
  saveInStorage,
  isValidEmail,
  clearStorage,
  clearAllStorage,
  logoutViaServer,
  logoutAllViaServer,
  generateHMacHash,
  setCookie,
  splitUsingSSSDynamic,
  convertArrayBufferToBase64String,
  joinUsingSSS,
  convertBase64StringToArrayBuffer,
  getErrorMessage,
  handleError,
  generateBCryptSalt,
  getEncryptionCurveFromStorage,
  getSigningCurveFromStorage,
  setActiveAppId,
  retainInStorage,
  hasStoredSession,
} from "./util/Utility";
import BayunError from "./constants/BayunError";
import BayunErrorUserMessages from "./constants/BayunErrorUserMessages";
import Constants from "./constants/Constants";
import * as appStorage from "./util/AppStorage";
import * as activeSession from "./util/ActiveSession";
import { ACCOUNT_KEY_HEADER } from "./rest/RestUtility";
import { SESSION_EVENTS, onSessionEvent } from "./util/SessionEvents";
import {
  isReauthenticationNeeded,
  isRefreshableAuthError,
  onReauthenticationNeeded,
  reportReauthenticationNeeded,
} from "./util/Reauthentication";
import {
  MAX_SIGNED_IN_SESSIONS,
  getAccountKey,
  listSessions,
  listSignedInSessions,
} from "./util/SessionRegistry";
import {
  lockText,
  unlockText,
  lockData,
  unlockData,
} from "./manager/EncryptionManager";
import { updateAndSaveStatistics } from "./manager/StatisticsManager";
import SharedPreferences from "./constants/SharedPreferences";
import {
  aeadDecryptWithAssociatedData,
  aeadEncryptWithPasscode,
  aeadEncryptWithAssociatedData,
  generateAesKey,
} from "./crypto/AuthenticatedEncryption";
import {
  appendSignatureAndMetadata,
  retrieveAndverifyLastSignature,
  signData,
  verifyMemberPublicKey,
  verifySignature,
  signOrgSettings,
  verifyOrgSettings,
  verifyAndPersistOrgSettings,
  buildOrgSettingsCanonical,
  ORG_SETTINGS_LAST_UPDATED_AT_KEYS,
  buildOrgSettingsTimestampsCanonical,
  createInitialOrgSettingsLastUpdatedAt,
  signOrgSettingsFromLastUpdatedAt,
  verifyOrgSettingsFromLastUpdatedAt,
  verifyAndPersistOrgSettingsFromLastUpdatedAt,
  assertNoOrgSettingsRollback,
  getMaxOrgSettingsLastUpdatedAt,
  isOrgSettingsLastUpdatedAtObject,
  getSettingLastUpdatedAtStorageKey,
  signDataAndAppendSignatureWithMetadata,
  getMemberAppPublicKeyContext,
  getBackdoorPublicKeyContext,
  getBackdoorPublicKeyContextLayer2,
  getMemberAppPublicKeyContextLayer2,
  getMemberPublicKeyContext,
  getOrgAppApprovalContext,
  verifyOrgAppApprovalSignature,
  getAdminPublicKeyContext,
  getGhostMemberIdContext,
  getGhostMemberPublicKeyContext,
  getOrgKeyContext,
  getOrgPrivateKeyContext,
  getOrgSettingsContext,
  getMemberKeyKekContext,
  getUserKeyKekContext,
  getUserKeyKekContextForUser,
  getMemberSigningPrivateKeyKekContext,
  getMemberSigningPublicKeyContext,
  getMemberSigningPublicKeyContextLayer2,
  getOrgPublicKeyContext,
  getOrgPublicKeyContextLayer2,
  getMemberPrivateKeyInnerKekContext,
  getOrgKeyKekAdminOrgContext,
  getOrgKeyKekMemberLockboxContext,
  getOrgPrivateKeyKekContext,
  getBackdoorPrivateKeyPartKekContext,
  getAdminPrivateKeyKekContext,
  getAdminSigningPrivateKeyKekContext,
  getGroupKeyContext,
  getGroupPrivateKeyContext,
  getGroupKeyKekContext,
  getGroupPrivateKeyKekContext,
  getGroupPublicKeyContext,
  getGroupTypeContext,
  getUserPublicKeyContext,
  getUserPrivateKeyOuterKekContext,
  getMemberPrivateKeyKekContext,
  verifyMessageForPublicKeyTag,
  verifyMessageForPublicKeyTagNewImplementation,
  getRecoveryKeyKekContext,
  getTransactionIdContext,
  getMessageFromSignatureString,
  removeSignatureLayersForPublicKeyTag,
} from "./util/SignatureUtil";
import { checkAndRefreshOrgSettings } from "./rest/api/internal/orgSettingsRefresh";
import {
  readMemberStatusHeader,
  refreshMemberStatusIfChanged,
} from "./rest/api/internal/memberStatusRefresh";
import SigningPublicKeyTags from "./constants/SigningPublicKeyTags";
import {
  generatePbkdf2Hash,
  derivePbkdf2Raw,
  derivePbkdf2Encoded,
  encodeKey,
  decodeKey,
} from "./crypto/PBKDF2";
import {
  hmacSha256Raw,
  hkdfSha256Raw,
  asRawKey,
} from "./crypto/KeyMaterial";
import {
  decryptAsymmetric,
  encryptAsymmetric,
  generateAndExportEccKeyPair,
  generateAndExportEccSigningKeyPair,
  publicKeysMatch,
} from "./util/AsymmetricEncryption";
import { deserializeThrift, serializeThrift } from "./thrift/ThriftFormatter";
import {
  deserializeUserRecoveryKeyFile,
  serializeUserRecoveryKeyFile,
} from "./util/RecoveryKeyUtil";
// import { async } from "regenerator-runtime";

// This is for vishwam fr
var script = document.createElement("script");
script.src = "https://code.jquery.com/jquery-3.4.1.js";
script.integrity = "sha256-WpOohJOqMqqyKL9FccASB9O0KwACQJpFTUBLTYOVvVU=";
script.crossOrigin = "anonymous";
document.getElementsByTagName("head")[0].appendChild(script);

var script1 = document.createElement("script");
script1.src = "https://unpkg.com/axios/dist/axios.min.js";
document.getElementsByTagName("head")[0].appendChild(script1);

/**
 * Encryption, key-generation and storage enums. Defined in constants/Enums.js and re-exported here
 * so the public SDK surface is unchanged; utility and REST modules import them from Enums.js
 * directly to avoid pulling this DOM-touching module into a non-browser context.
 */
import {
  EncryptionPolicy,
  KeyGenerationPolicy,
  EncryptionMode,
  LocalDataEncryptionMode,
} from "./constants/Enums";

export {
  EncryptionPolicy,
  KeyGenerationPolicy,
  EncryptionMode,
  LocalDataEncryptionMode,
};

/**
 * This enum represents all the key generation policies.
 */
export const GroupType = {
  PUBLIC: 0,
  PRIVATE: 1,
};
Object.freeze(GroupType);

/**
 * This enum represents all the possible results of authenticate call.
 */
export const AuthenticateResponse = {
  /**Authentication is successful*/
  SUCCESS: 1,
  /**Two Factor Authentication is enabled, need to verify security questions
   * to complete the authentication process. */
  VERIFY_SECURITY_QUESTIONS: 2,
  /**Two Factor Authentication is enabled, need to verify passphrase
   * to complete the authentication process. */
  VERIFY_PASSPHRASE: 3,
  /** The member is created but the signing with authorization key pair is
   * pending and needs to be done by the server side SDK. */
  AUTHORIZATION_PENDING: 4,
  /** This SSO member was registered but needs to set Security Questions
   * (and Passphrase) */
  SET_SECURITY_QUESTIONS_OR_PASSPHRASE: 5,
};
Object.freeze(AuthenticateResponse);

/**
 * Wraps a success callback so a finished sign-in is recorded before the host hears about it.
 *
 * Success is reported from many places inside the SDK, but every report that completes an
 * authentication carries AuthenticateResponse.SUCCESS and a sessionId — intermediate steps, such as
 * asking an unlinked member for a passcode, do not. Keying on that marks exactly the finished
 * sign-ins, whichever entry point the host started from.
 */
export const recordSignInOnSuccess = (successCallback) => async (data) => {
  if (data?.sessionId && data.authenticationResponse === AuthenticateResponse.SUCCESS) {
    try {
      await finalizeSignedInSession(data.sessionId);
    } catch (error) {
      // Bookkeeping must never turn a successful sign-in into a failed one.
      console.error("Could not record the finished sign-in", error);
    }
  }
  return successCallback ? successCallback(data) : undefined;
};

export class BayunCore {
  constructor(
    appId,
    appSecret,
    enableFaceRecognition,
    baseURL,
    bayunServerPublicKey,
  ) {
    if (process.env.SOURCE == Constants.SOURCE.BAYUN_ADMIN) {
      this.appId = appId;
      this.appSecret = appSecret;
      this.enableFaceRecognition = enableFaceRecognition;
      this.bayunServerPublicKey = bayunServerPublicKey;
      this.registerDeveloper = this.#_registerDeveloperImpl;
      this.encryptAsymmetric = this.#_encryptAsymmetricImpl;
      this.decryptAsymmetric = this.#_decryptAsymmetricImpl;
      this.generateAesKey = this.#_generateAesKeyImpl;
      this.appendSignatureAndMetadata = this.#_appendSignatureAndMetadataImpl;
      this.signData = this.#_signDataImpl;
      this.verifySignature = this.#_verifySignatureImpl;
      this.generateEccKeyPair = this.#_generateEccKeyPair;
      this.exportEccPrivateKey = this.#_exportEccPrivateKey;
      this.exportEccPublicKey = this.#_exportEccPublicKey;
      this.aeadEncryptWithAssociatedData = this.#_aeadEncryptWithAssociatedData;
      this.aeadDecryptWithAssociatedData = this.#_aeadDecryptWithAssociatedData;
      this.generateHMacHash = this.#_generateHMacHash;
      this.hmacSha256Raw = this.#_hmacSha256Raw;
      this.hkdfSha256Raw = this.#_hkdfSha256Raw;
      this.asRawKey = this.#_asRawKey;
      this.generatePbkdf2Hash = this.#_generatePbkdf2Hash;
      this.derivePbkdf2Raw = this.#_derivePbkdf2Raw;
      this.derivePbkdf2Encoded = this.#_derivePbkdf2Encoded;
      this.encodeKey = this.#_encodeKey;
      this.decodeKey = this.#_decodeKey;
      this.saveInStorage = this.#_saveInStorage;
      this.getFromStorage = this.#_getFromStorage;
      this.retainInStorage = this.#_retainInStorage;
      this.hasStoredSession = this.#_hasStoredSession;
      this.loginDeveloper = this.#_loginDeveloperImpl;
      this.loginWithAppCredentials = this.#_loginWithAppCredentialsImpl;
      this.loginViaValidatePasscode = this.#_loginViaValidatePasscode;
      this.getMemberLockBox = this.#_getMemberLockBox;
      this.updateUserRecoveryFlow = this.#_updateUserRecoveryFlow;
      this.retrieveAndverifyLastSignature = this.#_retrieveAndverifyLastSignature;
      this.deserializeUserRecoveryKeyFile =
        this.#_deserializeUserRecoveryKeyFileImpl;
      Constants.BASE_URL = baseURL + "lms/";
      // Every storage key is namespaced by appId so two Bayun apps on one origin cannot collide.
      // Set before any storage access, which is why it lives in the constructor.
      setActiveAppId(appId);
      return;
    }

    if (appId && appSecret) {
      this.appId = appId;
      this.appSecret = appSecret;
      this.enableFaceRecognition = enableFaceRecognition;
      Constants.BASE_URL = baseURL + "lms/";
      setActiveAppId(appId);
      this.bayunServerPublicKey = bayunServerPublicKey;
      // Storage-layout accessors, so host apps never have to read the state blob themselves.
      this.hasStoredSession = this.#_hasStoredSession;
      this.retainInStorage = this.#_retainInStorage;
      // Raw-key helpers available on all builds (portal / apps)
      this.generateAesKey = this.#_generateAesKeyImpl;
      this.generateHMacHash = this.#_generateHMacHash;
      this.hmacSha256Raw = this.#_hmacSha256Raw;
      this.hkdfSha256Raw = this.#_hkdfSha256Raw;
      this.asRawKey = this.#_asRawKey;
      this.generatePbkdf2Hash = this.#_generatePbkdf2Hash;
      this.derivePbkdf2Raw = this.#_derivePbkdf2Raw;
      this.derivePbkdf2Encoded = this.#_derivePbkdf2Encoded;
      this.encodeKey = this.#_encodeKey;
      this.decodeKey = this.#_decodeKey;
      this.encryptAsymmetric = this.#_encryptAsymmetricImpl;
      this.decryptAsymmetric = this.#_decryptAsymmetricImpl;
      this.aeadEncryptWithAssociatedData = this.#_aeadEncryptWithAssociatedData;
      this.aeadDecryptWithAssociatedData = this.#_aeadDecryptWithAssociatedData;
    } else {
      throw BayunError.ERROR_CREDENTIALS_CANNOT_BE_NULL;
    }
  }

  /**
   * Login With Passcode.
   *
   * @param {Object} params
   * @param {String} params.sessionId id of the session.
   * @param {String} params.orgName The name of the org for the member.
   * @param {String} params.orgMemberId The memberId of the member.
   * @param {String} params.passcode The passcode for the member account.
   * @param {Boolean} params.autoCreateMember Boolean flag that tells the SDK to create an member
   *                                    with the given credentials if an member doesnt exist for those.
   * @param {Callback} params.authorizeMemberCallback Called when member public key authorization is pending. The session is logged out. Returns sessionId, orgName, orgMemberId, error, and message. Call authorizeMember, then log in again.
   * @param {Callback} params.securityQuestionsCallback provide a custom UI block for taking User’s input.
   * @param {Callback} params.passphraseCallback provide a custom UI block for taking User’s input.
   *
   **/

  loginAgenticMember = async ({
    sessionId,
    orgName,
    orgMemberId,
    passcode,
    autoCreateMember,
    authorizeMemberCallback,
    securityQuestionsCallback,
    passphraseCallback,
    successCallback,
    failureCallback,
    localDataEncryptionMode,
  }) => {
    successCallback = recordSignInOnSuccess(successCallback);
    orgMemberId = orgMemberId.toLowerCase();
    orgName = orgName.toLowerCase();
    if (orgName && orgMemberId && passcode) {
      sessionId = await initAuthenticationProcess(
        sessionId,
        localDataEncryptionMode,
      );
      var isNewAuthentication = await getFromStorage(
        sessionId,
        SharedPreferences.IS_NEW_AUTHENTICATION,
      );
      if (!isNewAuthentication) {
        await completeReauthenticationWithPassphraseOrSQ(
          sessionId,
          this,
          successCallback,
          failureCallback,
          securityQuestionsCallback,
          passphraseCallback,
        );
        return;
      }

      try {
        await getApplicationKeyPair(
          sessionId,
          this.appId,
          this.appSecret,
          orgMemberId,
          this.bayunServerPublicKey,
        );
      } catch (error) {
        handleError(sessionId, error, failureCallback, "getApplicationKeyPair");
        return;
      }

      // get member info
      await getMemberInfo(
        sessionId,
        this,
        this.appId,
        this.appSecret,
        this.enableFaceRecognition,
        orgName,
        orgMemberId,
        passcode,
        null,
        autoCreateMember,
        Constants.LOGIN_FLOW_LOGIN,
        null,
        null,
        securityQuestionsCallback,
        passphraseCallback,
        authorizeMemberCallback,
        successCallback,
        failureCallback,
      );
    } else {
      await failureCallback(ErrorConstants.ERROR_CREDENTIALS_CANNOT_BE_NULL);
    }
  };

  /**
   * Register Member With Passcode.
   *
   * @param {Object} params
   * @param {String} params.sessionId id of the session.
   * @param {String} params.orgName The name of the org for the member.
   * @param {String} params.orgMemberId The memberId of the member.
   * @param {String} params.passcode The passcode for the member account.
   * @param {Callback} params.authorizeMemberCallback Called when member public key authorization is pending. The session is logged out. Returns sessionId, orgName, orgMemberId, error, and message. Call authorizeMember, then log in again.
   *
   **/

  registerAgenticMember = async ({
    sessionId,
    orgName,
    orgMemberId,
    passcode,
    localDataEncryptionMode,
    authorizeMemberCallback,
    successCallback,
    failureCallback,
  }) => {
    successCallback = recordSignInOnSuccess(successCallback);
    orgMemberId = orgMemberId.toLowerCase();
    orgName = orgName.toLowerCase();
    if (orgName && orgMemberId && passcode) {
      sessionId = await initAuthenticationProcess(
        sessionId,
        localDataEncryptionMode,
      );
      try {
        await getApplicationKeyPair(
          sessionId,
          this.appId,
          this.appSecret,
          orgMemberId,
          this.bayunServerPublicKey,
        );
      } catch (error) {
        handleError(sessionId, error, failureCallback, "getApplicationKeyPair");
        return;
      }
      // get member info
      await getMemberInfo(
        sessionId,
        this,
        this.appId,
        this.appSecret,
        this.enableFaceRecognition,
        orgName,
        orgMemberId,
        passcode,
        null,
        true,
        Constants.LOGIN_FLOW_REGISTER,
        null,
        null,
        null,
        null,
        authorizeMemberCallback,
        successCallback,
        failureCallback,
      );
    } else {
      failureCallback(ErrorConstants.ERROR_CREDENTIALS_CANNOT_BE_NULL);
    }
  };

  /**
   * Login Without Passcode.
   *
   * @param {Object} params
   * @param {String} params.sessionId id of the session.
   * @param {String} params.orgName The name of the org for the member.
   * @param {String} params.orgMemberId The memberId of the member.
   * @param {Callback} params.securityQuestionsCallback provide a custom UI block for taking User’s input.
   * @param {Callback} params.passphraseCallback provide a custom UI block for taking User’s input.
   *
   **/

  loginUserMember = async ({
    sessionId,
    orgName,
    orgMemberId,
    securityQuestionsCallback,
    passphraseCallback,
    successCallback,
    failureCallback,
    localDataEncryptionMode,
  }) => {
    successCallback = recordSignInOnSuccess(successCallback);
    orgMemberId = orgMemberId.toLowerCase();
    orgName = orgName.toLowerCase();

    sessionId = await initAuthenticationProcess(
      sessionId,
      localDataEncryptionMode,
    );

    if (
      !(await getFromStorage(
        sessionId,
        SharedPreferences.IS_NEW_AUTHENTICATION,
      ))
    ) {
      await completeReauthenticationWithPassphraseOrSQ(
        sessionId,
        this,
        successCallback,
        failureCallback,
        securityQuestionsCallback,
        passphraseCallback,
      );
      return;
    }

    try {
      // get some keysthen pass in memberinfo to save later
      await getApplicationKeyPair(
        sessionId,
        this.appId,
        this.appSecret,
        orgMemberId,
        this.bayunServerPublicKey,
      );
    } catch (error) {
      handleError(sessionId, error, failureCallback, "getApplicationKeyPair");
      return;
    }

    // get member info
    await getMemberInfo(
      sessionId,
      this,
      this.appId,
      this.appSecret,
      this.enableFaceRecognition,
      orgName,
      orgMemberId,
      null,
      null,
      false,
      Constants.LOGIN_FLOW_LOGIN,
      null,
      null,
      securityQuestionsCallback,
      passphraseCallback,
      null,
      successCallback,
      failureCallback,
    );
  };

  /**
   * Register Member Without Passcode.
   *
   * @param {Object} params
   * @param {String} params.sessionId id of the session.
   * @param {String} params.orgName The name of the org for the member.
   * @param {String} params.orgMemberId The memberId of the member.
   * @param {String} params.email Email of the user.
   * @param {boolean} params.isOrgOwnedEmail To identifiy if the email is org owned or user owned.
   * @param {Callback} params.authorizeMemberCallback Called when member public key authorization is pending. The session is logged out. Returns sessionId, orgName, orgMemberId, error, and message. Call authorizeMember, then log in again.
   * @param {Callback} params.newUserCredentialsCallback Block to be executed when the developer provide a custom UI block for taking User’s input.
   * @param {Callback} params.securityQuestionsCallback provide a custom UI block for taking User’s input.
   * @param {Callback} params.passphraseCallback provide a custom UI block for taking User’s input.
   * @param {String} [params.appId] the application this member belongs to, when it is not the one the
   *   SDK was initialised with. Defaults to the initialised appId.
   * @param {String} [params.appSecret] secret for that application. Defaults to the initialised one.
   * @param {String} [params.bayunServerPublicKey] server key for that application. Defaults to the
   *   initialised one.
   *
   **/
  registerUserMember = async ({
    sessionId,
    orgName,
    orgMemberId,
    email,
    isOrgOwnedEmail,
    localDataEncryptionMode,
    authorizeMemberCallback,
    newUserCredentialsCallback,
    securityQuestionsCallback,
    passphraseCallback,
    successCallback,
    failureCallback,
    appId,
    appSecret,
    bayunServerPublicKey,
  }) => {
    // The application this member belongs to, which is not necessarily the one the SDK was
    // initialised with: the Developer Portal registers members against whichever of a developer's
    // applications they picked. It used to pass those credentials by calling init again, which also
    // moved the storage namespace every key is built under — so a re-init in the wrong order made
    // every existing session's data unreachable. Naming them here is what removes that.
    const memberAppId = appId ?? this.appId;
    const memberAppSecret = appSecret ?? this.appSecret;
    const memberServerPublicKey =
      bayunServerPublicKey ?? this.bayunServerPublicKey;

    successCallback = recordSignInOnSuccess(successCallback);
    orgMemberId = orgMemberId.toLowerCase();
    orgName = orgName.toLowerCase();
    email = email.toLowerCase();

    if (!isValidEmail(email)) {
      failureCallback(BayunError.ERROR_NOT_A_VALID_EMAIL);
      return;
    }

    sessionId = await initAuthenticationProcess(
      sessionId,
      localDataEncryptionMode,
    );

    try {
      await getApplicationKeyPair(
        sessionId,
        memberAppId,
        memberAppSecret,
        orgMemberId,
        memberServerPublicKey,
      );
    } catch (error) {
      handleError(sessionId, error, failureCallback, "getApplicationKeyPair");
      return;
    }

    // get member info
    await getMemberInfo(
      sessionId,
      this,
      memberAppId,
      memberAppSecret,
      this.enableFaceRecognition,
      orgName,
      orgMemberId,
      null,
      email,
      false,
      Constants.LOGIN_FLOW_REGISTER,
      isOrgOwnedEmail,
      newUserCredentialsCallback,
      securityQuestionsCallback,
      passphraseCallback,
      authorizeMemberCallback,
      successCallback,
      failureCallback,
    );
  };

  /**
   * Register Developer Without Passcode.
   *
   * @param {String} sessionId id of the session.
   * @param {String} email Email of the user.
   * @param {boolean} isOrgOwnedEmail To identifiy if the email is org owned or user owned.
   * @param {Callback} newUserCredentialsCallback Block to be executed when the developer provide a custom UI block for taking User’s input.
   * @param {Callback} securityQuestionsCallback provide a custom UI block for taking User’s input.
   * @param {Callback} passphraseCallback provide a custom UI block for taking User’s input.
   *
   **/
  #_registerDeveloperImpl = async (
    sessionId,
    email,
    isOrgOwnedEmail,
    newUserCredentialsCallback,
    securityQuestionsCallback,
    passphraseCallback,
    successCallback,
    failureCallback,
    localDataEncryptionMode,
  ) => {
    successCallback = recordSignInOnSuccess(successCallback);
    email = email.toLowerCase();

    if (!isValidEmail(email)) {
      failureCallback(BayunError.ERROR_NOT_A_VALID_EMAIL);
      return;
    }

    sessionId = await initAuthenticationProcess(
      sessionId,
      localDataEncryptionMode,
    );

    const response = await registerDeveloperAccount(
      sessionId,
      email,
      isOrgOwnedEmail,
      failureCallback,
    );

    await saveInStorage(sessionId, SharedPreferences.IS_DEVELOPER, "true");

    if (!response.data.newUser && response.data.multiFactorAuthentication != null) {
      // User is already registered, making a validation flow from here
      await getTwoFAData(
        sessionId,
        this,
        null,
        null,
        null,
        successCallback,
        failureCallback,
        securityQuestionsCallback,
        passphraseCallback,
        null, // authorizeMemberCallback
      );
    } // In register flow we are checking if newUserCredentialsCallback is not null then it means the user will give its own UI.
    else if (newUserCredentialsCallback) {
      // return success with status to set SQ and passphrase
      newUserCredentialsCallback({
        sessionId,
        securityQuestions: null,
        authenticationResponse:
          AuthenticateResponse.SET_SECURITY_QUESTIONS_OR_PASSPHRASE,
        registerDeveloperResponse: response.data,
      });
    }
  };

  /**
   * Login Developer Without Passcode.
   *
   * @param {String} sessionId id of the session.
   * @param {String} email Email of the user.
   * @param {boolean} isOrgOwnedEmail To identifiy if the email is org owned or user owned.
   * @param {Callback} newUserCredentialsCallback Block to be executed when the developer provide a custom UI block for taking User’s input.
   * @param {Callback} securityQuestionsCallback provide a custom UI block for taking User’s input.
   * @param {Callback} passphraseCallback provide a custom UI block for taking User’s input.
   *
   **/
  #_loginDeveloperImpl = async (
    sessionId,
    email,
    securityQuestionsCallback,
    passphraseCallback,
    successCallback,
    failureCallback,
    localDataEncryptionMode,
  ) => {
    successCallback = recordSignInOnSuccess(successCallback);
    if (email) {
      email = email.toLowerCase();
    }

    if (!isValidEmail(email)) {
      failureCallback(BayunError.ERROR_NOT_A_VALID_EMAIL);
      return;
    }

    sessionId = await initAuthenticationProcess(
      sessionId,
      localDataEncryptionMode,
    );

    if (
      !(await getFromStorage(
        sessionId,
        SharedPreferences.IS_NEW_AUTHENTICATION,
      ))
    ) {
      await completeReauthenticationWithPassphraseOrSQ(
        sessionId,
        this,
        successCallback,
        failureCallback,
        securityQuestionsCallback,
        passphraseCallback,
      );
      return;
    }

    const resp = await loginDeveloperAccount(sessionId, email, failureCallback);

    if (resp.isDeveloper === "true") {
      await getTwoFAData(
        sessionId,
        this,
        null,
        null,
        null,
        successCallback,
        failureCallback,
        securityQuestionsCallback,
        passphraseCallback,
        null, // authorizeMemberCallback
      );
    } else {
      await loginWithAppCredentials(
        sessionId,
        await getFromStorage(sessionId, SharedPreferences.ORG_NAME),
        await getFromStorage(sessionId, SharedPreferences.ORG_MEMBER_ID),
        false,
        true,
        successCallback,
        failureCallback,
        securityQuestionsCallback,
        passphraseCallback,
        this,
      );
    }
  };

  #_loginWithAppCredentialsImpl = async (
    sessionId,
    orgName,
    orgMemberId,
    orgSwitchRequest,
    emailValidated,
    successCallback,
    failureCallback,
    securityQuestionsCallback,
    passphraseCallback,
    localDataEncryptionMode,
  ) => {
    successCallback = recordSignInOnSuccess(successCallback);
    sessionId = await initAuthenticationProcess(
      sessionId,
      localDataEncryptionMode,
    );

    await loginWithAppCredentials(
      sessionId,
      orgName,
      orgMemberId,
      orgSwitchRequest,
      emailValidated,
      successCallback,
      failureCallback,
      securityQuestionsCallback,
      passphraseCallback,
      this,
    );
  };

  #_loginViaValidatePasscode = async (
    sessionId,
    appId,
    passcode,
    successCallback,
    failureCallback,
    securityQuestionsCallback,
    passphraseCallback,
  ) => {
    successCallback = recordSignInOnSuccess(successCallback);
    await loginViaValidatePasscode(
      sessionId,
      appId,
      passcode,
      successCallback,
      failureCallback,
      securityQuestionsCallback,
      passphraseCallback,
    );
  };

  // #_registerUserMemberImpl = async (
  //   sessionId,
  //   orgName,
  //   orgMemberId,
  //   email,
  //   isOrgOwnedEmail,
  //   authorizeMemberCallback,
  //   newUserCredentialsCallback,
  //   securityQuestionsCallback,
  //   passphraseCallback,
  //   successCallback,
  //   failureCallback,
  // ) => {
  //   return await registerUserMember(
  //     sessionId,
  //     orgName,
  //     orgMemberId,
  //     email,
  //     isOrgOwnedEmail,
  //     authorizeMemberCallback,
  //     newUserCredentialsCallback,
  //     securityQuestionsCallback,
  //     passphraseCallback,
  //     successCallback,
  //     failureCallback,
  //   );
  // };

  #_generateAesKeyImpl = async () => {
    return await generateAesKey();
  };

  // Public crypto entry points go through the AsymmetricEncryption wrappers rather than the
  // raw ecc* primitives, so an omitted curve resolves from the active session instead of
  // throwing. The primitives themselves stay strict.
  #_encryptAsymmetricImpl = async (
    plaintext,
    publicKey,
    encryptionType,
    eccCurve,
    associatedData,
  ) => {
    return await encryptAsymmetric(plaintext, publicKey, associatedData, eccCurve);
  };

  #_aeadEncryptWithAssociatedData = async (
    plaintext,
    associatedData,
    baseKeyAsString,
  ) => {
    return await aeadEncryptWithAssociatedData(
      plaintext,
      associatedData,
      baseKeyAsString,
    );
  };

  /** @deprecated Use hmacSha256Raw for AES keys, or encodeKey(hmacSha256Raw(...)) for wire. */
  #_generateHMacHash = async (key, message) => {
    return await generateHMacHash(key, message);
  };

  #_hmacSha256Raw = async (key, message) => {
    return await hmacSha256Raw(key, message);
  };

  #_hkdfSha256Raw = async (ikm, salt, info, length) => {
    return await hkdfSha256Raw(ikm, salt, info, length);
  };

  #_asRawKey = (value) => {
    return asRawKey(value);
  };

  /** @deprecated Use derivePbkdf2Encoded for store/send, or derivePbkdf2Raw for AES. */
  #_generatePbkdf2Hash = async (passcode, salt) => {
    return await generatePbkdf2Hash(passcode, salt);
  };

  #_derivePbkdf2Raw = async (password, saltBase64) => {
    return await derivePbkdf2Raw(password, saltBase64);
  };

  #_derivePbkdf2Encoded = async (password, saltBase64) => {
    return await derivePbkdf2Encoded(password, saltBase64);
  };

  #_encodeKey = (raw) => {
    return encodeKey(raw);
  };

  #_decodeKey = (encoded) => {
    return decodeKey(encoded);
  };

  #_aeadDecryptWithAssociatedData = async (
    encryptedTextAsString,
    associatedDataAsString,
    baseKeyAsString,
  ) => {
    return await aeadDecryptWithAssociatedData(
      encryptedTextAsString,
      associatedDataAsString,
      baseKeyAsString,
    );
  };

  #_deserializeUserRecoveryKeyFileImpl = (content) => {
    return deserializeUserRecoveryKeyFile(content);
  };

  #_decryptAsymmetricImpl = async (
    encryptedText,
    privateKey,
    keyEncryptionKey,
    associatedData,
    eccCurve,
  ) => {
    return await decryptAsymmetric(
      encryptedText,
      privateKey,
      keyEncryptionKey,
      associatedData,
      eccCurve,
    );
  };

  #_appendSignatureAndMetadataImpl = async (
    publicKey,
    signature,
    publicKeyTag,
    context,
  ) => {
    return await appendSignatureAndMetadata(
      publicKey,
      signature,
      publicKeyTag,
      context,
    );
  };

  #_retrieveAndverifyLastSignature = async (sessionId, messageWithSignatures) => {
    return await retrieveAndverifyLastSignature(sessionId, messageWithSignatures);
  };

  #_signDataImpl = async (
    plainTextString,
    privateKeyString,
    context,
    encryptionTypeOrSigningCurve,
    signingCurveOrSessionId,
    maybeSessionId,
  ) => {
    // Supported call shapes:
    // (text, key, context, signingCurve, sessionId)
    // (text, key, context, encryptionType, signingCurve) — legacy portal
    // (text, key, context, encryptionType, signingCurve, sessionId)
    let signingCurve = encryptionTypeOrSigningCurve;
    let sessionId = signingCurveOrSessionId;
    const looksLikeEncryptionType =
      encryptionTypeOrSigningCurve === "ECC" ||
      encryptionTypeOrSigningCurve === "RSA";

    if (maybeSessionId !== undefined) {
      signingCurve = signingCurveOrSessionId;
      sessionId = maybeSessionId;
    } else if (looksLikeEncryptionType) {
      signingCurve = signingCurveOrSessionId;
      sessionId = undefined;
    }

    return await signData(
      plainTextString,
      privateKeyString,
      context,
      signingCurve,
      sessionId,
    );
  };

  #_generateEccKeyPair = async (eccCurve) => {
    return await generateEccKeyPair(
      eccCurve || (await getEncryptionCurveFromStorage()),
    );
  };

  #_exportEccPrivateKey = async (cryptoKey) => {
    return await exportEccPrivateKey(cryptoKey);
  };

  #_exportEccPublicKey = async (cryptoKey) => {
    return await exportEccPublicKey(cryptoKey);
  };

  #_verifySignatureImpl = async (
    plainTextString,
    signature,
    publicKey,
    context,
    eccCurve,
  ) => {
    return await verifySignature(
      plainTextString,
      signature,
      publicKey,
      context,
      eccCurve,
    );
  };

  #_saveInStorage = async (sessionId, identifier, data) => {
    return await saveInStorage(sessionId, identifier, data);
  };

  #_getFromStorage = async (sessionId, identifier) => {
    return await getFromStorage(sessionId, identifier);
  };

  #_retainInStorage = async (sessionId, identifiersToKeep) => {
    return await retainInStorage(sessionId, identifiersToKeep);
  };

  #_hasStoredSession = (sessionId) => {
    return hasStoredSession(sessionId);
  };

  #_getMemberLockBox = async (sessionId, orgMemberId) => {
    return await getMemberLockBox(sessionId, orgMemberId);
  };


  #_updateUserRecoveryFlow = async (sessionId, failureCallback) => {
    return await updateUserRecoveryFlow(sessionId, failureCallback);
  };

  /**
   * Authorize a member public key using the authorization app credentials.
   *
   * @param {Object} params
   * @param {String} params.orgName The name of the org for the member.
   * @param {String} params.orgMemberId The memberId of the member.
   * @param {Callback} params.successCallback Called when authorization succeeds. Log in again. Returns authenticationResponse and message.
   * @param {Callback} params.failureCallback Called when authorization fails.
   */
  authorizeMember = async ({
    orgName,
    orgMemberId,
    successCallback,
    failureCallback,
  }) => {
    let bayunServerPublicKey = this.bayunServerPublicKey;
    if (bayunServerPublicKey) {
      bayunServerPublicKey = bayunServerPublicKey.replace(/,/g, "\n");
    }
    await authorizeMemberAPI(
      this.appId,
      this.appSecret,
      orgName,
      orgMemberId,
      bayunServerPublicKey,
      successCallback,
      failureCallback,
    );
  };

  setNewUserCredentials = async ({
    sessionId,
    securityQuestions,
    minimumCorrectQuestions = 3,
    passphrase,
    registerFaceId,
    authorizeMemberCallback,
    successCallback,
    failureCallback,
  }) => {
    successCallback = recordSignInOnSuccess(successCallback);
    const email = await getFromStorage(
      sessionId,
      SharedPreferences.EMAIL_ADDRESS,
    );

    if (
      await getFromStorage(sessionId, SharedPreferences.ENABLE_FACE_RECOGNITION)
    ) {
      await saveInStorage(
        sessionId,
        SharedPreferences.REGISTER_FACE_ID,
        registerFaceId,
      );
    } else {
      if (registerFaceId == true) {
        try {
          throw BayunError.ERROR_CANNOT_SET_PARAMETER_REGISTER_FACE_ID_TO_TRUE_AS_ENABLE_FACE_RECOGNITION_IS_SET_TO_FALSE;
        } catch (err) {
          console.error("error : ", err);
        }
        return;
      }
    }

    let newSuccessCallback = null;
    let isAlsoSetPassphrase = false;

    if (passphrase) {
      isAlsoSetPassphrase = true;
      newSuccessCallback = async () => {
        await createPassphrase(
          sessionId,
          email,
          passphrase,
          authorizeMemberCallback,
          successCallback,
          failureCallback,
        );
        await saveInStorage(
          sessionId,
          SharedPreferences.MFA_SETTING,
          Constants.MULTI_FACTOR_SINGLE_FA_WITH_PASSCODE,
        );
      };
    } else {
      newSuccessCallback = successCallback;
    }

    await createSecurityQuestions(
      sessionId,
      email,
      securityQuestions,
      minimumCorrectQuestions,
      isAlsoSetPassphrase,
      authorizeMemberCallback,
      newSuccessCallback,
      failureCallback,
    );

    await saveInStorage(
      sessionId,
      SharedPreferences.MFA_SETTING,
      Constants.MULTI_FACTOR_SINGLE_FA_WITH_PASSCODE,
    );
  };

  changePasscode = async ({
    sessionId,
    currentPasscode,
    newPasscode,
    successCallback,
    failureCallback,
  }) => {
    await changePasscodeImpl(
      sessionId,
      currentPasscode,
      newPasscode,
      successCallback,
      failureCallback,
    );
  };

  // getMemberPublicKey = async (
  //   // sessionId,
  //   appId,
  //   appSecret,
  //   orgName,
  //   orgMemberId,
  //   successCallback,
  //   failureCallback
  // ) => {
  //   await getMemberPublicKeyImpl(
  //     // sessionId,
  //     appId,
  //     appSecret,
  //     orgName,
  //     orgMemberId,
  //     successCallback,
  //     failureCallback
  //   );
  // };

  /**
   * The function creates a new private group with Bayun.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} groupName The name of the group. It is optional.
   * @param {String} context The context to be used to make the HMAC hash of groupKey on.
   * @returns {Promise} the response of which contains an object with the groupId and groupkey.
   */
  createGroup = async ({ sessionId, groupName, groupType }) =>
    createNewGroup(sessionId, groupName, groupType);

  /**
   * This method returns the joined groups of an member.
   *
   * @param {String} sessionId id of the session in question.
   */
  getMyGroups = async ({ sessionId }) => getJoinedGroups(sessionId);

  /**
   * This method returns the list of all the public unjoined groups that the member can join.
   *
   * @param {String} sessionId id of the session in question.
   * @returns Array of the available public groups.
   */
  getUnjoinedPublicGroups = async ({ sessionId }) =>
    getUnjoinedGroupsForMember(sessionId);

  /**
   * This method joins a new public group.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} groupId id of the group to join.
   */
  joinPublicGroup = async ({ sessionId, groupId }) =>
    joinNewPublicGroup(sessionId, groupId);

  /**
   * This function adds the given member to the given group, granting the user the keys for the group.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} groupId Id of the group to which the user is to be added.
   * @param {String} orgMemberId OrgMemberId of the member to be added to the group.
   * @param {String} orgName Name of the org of the member to be added to the group.
   */
  addParticipantToGroup = async ({
    sessionId,
    groupId,
    orgMemberId,
    orgName,
  }) => addNewParticipantToGroup(sessionId, groupId, orgMemberId, orgName);

  /**
   * This function adds the given list of members to the given group, granting them the keys for the group.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} groupId Id of the group to which the user is to be added.
   * @param {List} groupParticipants the list of objects of participants to be added consisting of
   *                                "orgName" and "orgMemberId"
   */
  addParticipantsToGroup = async ({ sessionId, groupId, groupParticipants }) =>
    addNewParticipantsToGroup(sessionId, groupId, groupParticipants);

  /**
   * This function lets the logged in user leave the group associated with the given groupId.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} groupId The id of the group to leave.
   */
  leaveGroup = async ({ sessionId, groupId }) =>
    leaveGroupById(sessionId, groupId);

  /**
   * This function deletes a group associated with the given groupId.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} groupId The id of the group to be deleted.
   */
  deleteGroup = async ({ sessionId, groupId }) =>
    deleteGroupWithId(sessionId, groupId);

  getGroupById = async ({ sessionId, groupId }) =>
    getGroupById(sessionId, groupId);

  /**
   * This function removed the given credentials from a group.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} groupId id of the group from who the member is to be removed.
   * @param {String} orgMemberId memberId of the member to be removed.
   * @param {String} orgName org name of the member to be removed.
   */
  removeParticipantFromGroup = async ({
    sessionId,
    groupId,
    orgMemberId,
    orgName,
  }) => removeParticipantOfGroup(sessionId, orgMemberId, orgName, groupId);

  /**
   * This function removes the given list of participants from a group.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} groupId id of the group from who the member is to be removed.
   * @param {String} participantsInfo credentials of the members to be removed.
   */
  removeParticipantsFromGroup = async ({
    sessionId,
    groupId,
    participantsInfo,
  }) => removeParticipantsOfGroup(sessionId, groupId, participantsInfo);

  /**
   * This function removes the given list of participants except from given list.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} groupId id of the group from who the member is to be removed.
   * @param {String} participantsInfo credentials of the members to be removed.
   * @param {Boolean} removeCallingParticipant boolean variale, has to be set true if we want to remove calling Participant itself, by default it is set false.
   */
  removeParticipantsExceptList = async ({
    sessionId,
    groupId,
    participantsInfo,
    removeCallingParticipant,
  }) =>
    removeParticipantsFromGroupExceptList(
      sessionId,
      groupId,
      participantsInfo,
      removeCallingParticipant,
    );

  /**
   * This function creates an ECC key pair with signing key usages.
   *
   * @returns {CryptoKeyPair} the key generated key pair.
   */
  generateSigningKeyPair = async (eccCurve) =>
    generateEccSigningKeyPair(eccCurve || (await getSigningCurveFromStorage()));

  /**
   * This function returns an encryption key depending on the encryption policy.
   *
   * @param {String} sessionId id of the session in question.
   * @param {EncryptionPolicy} encryptionPolicy the encryption policy decides
   *                                            the key that will be used.
   * @param {KeyGenerationPolicy} keyGenerationPolicy the key generation policy
   *                                                  decides how the key is generated.
   * @param {String} groupId  the groupId is needed to get the key associated
   *                          with group, in case the encryptionPolicy is group.
   */
  getLockingKeyForEncryptionPolicyAsString = async ({
    sessionId,
    encryptionPolicy,
    keyGenerationPolicy,
    groupId,
  }) =>
    getEncryptionKeyAsString(
      sessionId,
      encryptionPolicy,
      keyGenerationPolicy,
      groupId,
    );

  /**
   * This function returns an encryption key depending on the encryption policy.
   *
   * @param {String} sessionId id of the session in question.
   * @param {EncryptionPolicy} encryptionPolicy the encryption policy decides
   *                                            the key that will be used.
   * @param {KeyGenerationPolicy} keyGenerationPolicy the key generation policy
   *                                                  decides how the key is generated.
   * @param {String} groupId  the groupId is needed to get the key associated
   *                          with group, in case the encryptionPolicy is group.
   */
  getLockingKey = async ({
    sessionId,
    encryptionPolicy,
    keyGenerationPolicy,
    groupId,
  }) =>
    getEncryptionKey(sessionId, encryptionPolicy, keyGenerationPolicy, groupId);

  /**
   * Logs one account out and removes its saved data. Other accounts signed in on this origin keep
   * their data and their tabs.
   *
   * @param {String} sessionId id of the session in question.
   */
  logout = async ({ sessionId }) => {
    try {
      let encryptionCount = await getFromStorage(
        sessionId,
        SharedPreferences.ENCRYPTION_COUNT,
      );
      let decryptionCount = await getFromStorage(
        sessionId,
        SharedPreferences.DECRYPTION_COUNT,
      );

      if (encryptionCount || decryptionCount) {
        await updateAndSaveStatistics(sessionId, true, false, false, false);
      }

      await logoutViaServer(sessionId);
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      clearStorage(sessionId);
    }
  };

  /**
   * Logs every account signed in from this browser out, on the server as well as locally.
   *
   * One request ends the whole bundle: any account in it can name the bundle, so this no longer
   * leaves the other accounts' server rows to expire on their own.
   *
   * Rejects and keeps local state when the bundle could not be ended, rather than showing a
   * signed-out screen while the accounts are still live on the server.
   *
   * A rejection does not always mean the server refused it. Building the client reads the session's
   * stored appId, which a tab that merely adopted the session cannot see, so the call can fail
   * before any request goes out; retrying from the tab that signed in will work.
   *
   * @throws when the bundle could not be ended, whether or not the server was reached.
   */
  logoutAll = async ({ sessionId } = {}) => {
    const active = sessionId || activeSession.getActiveSessionId();
    if (active) {
      await logoutAllViaServer(active);
    }
    clearAllStorage();
  };

  /**
   * This method verifies the user's passphrase.
   *
   * @param {String} sessionId  id of the session in question
   * @param {String} passphrase the passphrase of the user associated with the member.
   * @param {Callback} authorizeMemberCallback Called when member public key authorization is pending. The session is logged out. Returns sessionId, orgName, orgMemberId, error, and message. Call authorizeMember, then log in again.
   */
  validatePassphrase = async ({
    sessionId,
    passphrase,
    // passcode,
    authorizeMemberCallback,
    successCallback,
    failureCallback,
  }) => {
    successCallback = recordSignInOnSuccess(successCallback);
    // console.log("passcode1 = ", passcode);
    // addLoadMask();
    await validatePassphraseAPI(
      sessionId,
      passphrase,
      // passcode,
      authorizeMemberCallback,
      successCallback,
      failureCallback,
    );
  };

  /**
   * This method verifies the user's passphrase.
   *
   * @param {String} sessionId  id of the session in question
   * @param {String} answers the liist answers of the user associated with the member.
   * @param {Callback} authorizeMemberCallback Called when member public key authorization is pending. The session is logged out. Returns sessionId, orgName, orgMemberId, error, and message. Call authorizeMember, then log in again.
   */
  validateSecurityQuestions = async ({
    sessionId,
    answers,
    // passcode,
    authorizeMemberCallback,
    successCallback,
    failureCallback,
  }) => {
    successCallback = recordSignInOnSuccess(successCallback);
    // addLoadMask();
    await validateSecurityQuestionsAPI(
      sessionId,
      answers,
      // passcode,
      authorizeMemberCallback,
      successCallback,
      failureCallback,
    );
  };

  /**
   * This function returns locked text.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} text to be locked.
   * @param {EncryptionPolicy} encryptionPolicy the encryption policy decides
   *                                            the key that will be used.
   * @param {KeyGenerationPolicy} keyGenrationPolicy It decides the policy that will be used.
   * @param {String} groupId  the groupId is needed to get the key associated
   *                          with group, in case the encryptionPolicy is group.
   */

  lockText = async ({
    sessionId,
    text,
    encryptionPolicy,
    keyGenerationPolicy,
    groupId,
  }) =>
    lockText(
      sessionId,
      text,
      encryptionPolicy,
      keyGenerationPolicy,
      groupId,
      false,
    );

  /**
   * This function returns plain text.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} lockedText to be unlocked.
   *
   */
  unlockText = async ({ sessionId, lockedText }) =>
    unlockText(sessionId, lockedText, false);

  /**
   * This function returns locked data.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} text Data to be locked.
   * @param {EncryptionPolicy} encryptionPolicy the encryption policy decides
   *                                            the key that will be used.
   * @param {KeyGenerationPolicy} keyGenrationPolicy It decides the policy that will be used.
   * @param {String} groupId  the groupId is needed to get the key associated
   *                          with group, in case the encryptionPolicy is group.
   */
  lockData = async ({
    sessionId,
    text,
    encryptionPolicy,
    keyGenerationPolicy,
    groupId,
  }) =>
    lockData(sessionId, text, encryptionPolicy, keyGenerationPolicy, groupId);

  /**
   * This function returns plain data.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} lockedData Data to be unlocked.
   *
   */
  unlockData = async ({ sessionId, lockedData }) =>
    unlockData(sessionId, lockedData);

  /**
   * This function returns locked file text.
   *
   * @param {String} sessionId id of the session in question.
   * @param {String} text to be locked.
   * @param {EncryptionPolicy} encryptionPolicy the encryption policy decides
   *                                            the key that will be used.
   * @param {KeyGenerationPolicy} keyGenrationPolicy It decides the policy that will be used.
   * @param {String} groupId  the groupId is needed to get the key associated
   *                          with group, in case the encryptionPolicy is group.
   */

  lockFileText = async ({
    sessionId,
    text,
    encryptionPolicy,
    keyGenerationPolicy,
    groupId,
  }) =>
    lockText(
      sessionId,
      text,
      encryptionPolicy,
      keyGenerationPolicy,
      groupId,
      true,
    );

  unlockFileText = async ({ sessionId, lockedText }) =>
    unlockText(sessionId, lockedText, true);
}

const init = (params) => {

  const requiredKeys = [
    "bayunAppId",
    "bayunAppSecret",
    "baseURL",
    "bayunServerPublicKey",
    "enableFaceRecognition",
  ];
  if (params == null || typeof params !== "object") {
    throw new Error(
      "Please provide params as an object containing keys {bayunAppId, bayunAppSecret, baseURL, bayunServerPublicKey, enableFaceRecognition}"
    );
  }
  const hasAllKeys = requiredKeys.every((key) =>
    Object.prototype.hasOwnProperty.call(params, key)
  );
  if (!hasAllKeys) {
    throw new Error(
      "Please provide all the credentials of type {bayunAppId: xxxx, bayunAppSecret: xxxx, baseURL: xxxx, bayunServerPublicKey: xxxx, enableFaceRecognition: xxxx}"
    );
  }

  if (!params.baseURL) {
    params.baseURL = "https://digilockbox.com/";
  }
  // console.log("process.env.INCLUDE_VISHWAM 1 = ", process.env.INCLUDE_VISHWAM);
  if (process.env.INCLUDE_VISHWAM == false) {
    params.enableFaceRecognition = false;
  }
  if (
    params.enableFaceRecognition &&
    !params.baseURL.includes("digilockbox.com") &&
    !params.baseURL.includes("localhost:")
  ) {
    try {
      throw BayunError.ERROR_FACE_RECOGNITION_IS_DISABLED_FOR_THIS_DOMAIN;
    } catch (err) {
      console.error("error : ", err);
    }
    return;
  }
  if (params.bayunServerPublicKey) {
    params.bayunServerPublicKey = params.bayunServerPublicKey.replace(
      /,/g,
      "\n",
    );
  }
  if (!params.bayunServerPublicKey) {
    params.bayunServerPublicKey =
      "-----BEGIN PUBLIC KEY-----\n" +
      "MHYwEAYHKoZIzj0CAQYFK4EEACIDYgAEdctXBsSUFQt4+JzAeZyhppiTO3GT7Jpz\n" +
      "HN0/fymuzAGikS4vRDFcju4e4FIwGpaBgaPtUE1X7NqYo9xTlTDB1QkcQsiy64QJ\n" +
      "/FxCHYEjBZulkbgp09Ku87snavsPko18\n" +
      "-----END PUBLIC KEY-----\n";
  }
  setCookie("baseURL", params.baseURL, 30);
  return new BayunCore(
    params.bayunAppId,
    params.bayunAppSecret,
    params.enableFaceRecognition,
    params.baseURL,
    params.bayunServerPublicKey,
  );
};

window.BayunCore = {
  init: init,
  // Namespaced browser storage for host apps: per-account, per-app, and removed on logout with the
  // rest of the session's data. See util/AppStorage.js. Not for secrets.
  appStorage: appStorage,
  /**
   * Which account this tab is acting as, which account holds the origin's server credential, and
   * the list of accounts signed in on this origin. See util/ActiveSession.js.
   */
  session: {
    getActiveSessionId: activeSession.getActiveSessionId,
    setActiveSessionId: activeSession.setActiveSessionId,
    clearActiveSessionId: activeSession.clearActiveSessionId,
    hasCredential: activeSession.hasCredential,
    // Host apps with their own HTTP clients need this to address the right account.
    getAccountKey: getAccountKey,
    ACCOUNT_KEY_HEADER: ACCOUNT_KEY_HEADER,
    listSessions: listSessions,
    // What an account switcher should show: finished sign-ins this tab can act as.
    listSignedInSessions: listSignedInSessions,
    MAX_SIGNED_IN_SESSIONS: MAX_SIGNED_IN_SESSIONS,
    onSessionEvent: onSessionEvent,
    EVENTS: SESSION_EVENTS,
    // A session turning out to be over. Hosts register once at startup and clear their auth state;
    // the classifiers are for host code that has to judge an error it caught itself.
    onReauthenticationNeeded: onReauthenticationNeeded,
    isReauthenticationNeeded: isReauthenticationNeeded,
    isRefreshableAuthError: isRefreshableAuthError,
  },
  EncryptionPolicy: EncryptionPolicy,
  GroupType: GroupType,
  AuthenticateResponse: AuthenticateResponse,
  KeyGenerationPolicy: KeyGenerationPolicy,
  LocalDataEncryptionMode: LocalDataEncryptionMode,
  BayunError: BayunError,
  BayunErrorUserMessages: BayunErrorUserMessages,
};

// Keep private access in closure
const internalAPI = {
  saveInStorage,
  getFromStorage,
  aeadEncryptWithAssociatedData,
  aeadDecryptWithAssociatedData,
  aeadEncryptWithPasscode,
  signData,
  generateHMacHash,
  hmacSha256Raw,
  hkdfSha256Raw,
  asRawKey,
  encryptAsymmetric,
  decryptAsymmetric,
  generateAndExportEccKeyPair,
  generateAndExportEccSigningKeyPair,
  generateBCryptSalt,
  retrieveAndverifyLastSignature,
  prepareSetSecurityQuestionsRequest,
  buildUserValidationSecret,
  getUserValidationSecretFromStorage,
  getAuthAnswerHashes,
  decryptAndGetUserPrivateKey,
  generatePbkdf2Hash,
  derivePbkdf2Raw,
  derivePbkdf2Encoded,
  encodeKey,
  decodeKey,
  prepareSetNewPassphraseRequest,
  verifyMemberPublicKey,
  signDataAndAppendSignatureWithMetadata,
  appendSignatureAndMetadata,
  splitUsingSSSDynamic,
  generateAesKey,
  convertArrayBufferToBase64String,
  verifySignature,
  signOrgSettings,
  verifyOrgSettings,
  verifyAndPersistOrgSettings,
  buildOrgSettingsCanonical,
  ORG_SETTINGS_LAST_UPDATED_AT_KEYS,
  buildOrgSettingsTimestampsCanonical,
  createInitialOrgSettingsLastUpdatedAt,
  signOrgSettingsFromLastUpdatedAt,
  verifyOrgSettingsFromLastUpdatedAt,
  verifyAndPersistOrgSettingsFromLastUpdatedAt,
  assertNoOrgSettingsRollback,
  getMaxOrgSettingsLastUpdatedAt,
  isOrgSettingsLastUpdatedAtObject,
  getSettingLastUpdatedAtStorageKey,
  checkAndRefreshOrgSettings,
  readMemberStatusHeader,
  refreshMemberStatusIfChanged,
  // For embedded panels with their own HTTP client: they see session failures the SDK's client never
  // does, and reporting them here is what reaches the host's handler.
  reportReauthenticationNeeded,
  joinUsingSSS,
  convertBase64StringToArrayBuffer,
  verifyMessageForPublicKeyTag,
  verifyMessageForPublicKeyTagNewImplementation,
  verifyOrgAppApprovalSignature,
  serializeThrift,
  deserializeThrift,
  serializeUserRecoveryKeyFile,
  deserializeUserRecoveryKeyFile,
  getMessageFromSignatureString,
  publicKeysMatch,
  removeSignatureLayersForPublicKeyTag,
  // Context methods organized in a namespace
  context: {
    getMemberAppPublicKeyContext,
    getBackdoorPublicKeyContext,
    getBackdoorPublicKeyContextLayer2,
    getMemberAppPublicKeyContextLayer2,
    getMemberPublicKeyContext,
    getOrgAppApprovalContext,
    getAdminPublicKeyContext,
    getGhostMemberIdContext,
    getGhostMemberPublicKeyContext,
    getOrgKeyContext,
    getOrgPrivateKeyContext,
    getOrgSettingsContext,
    getMemberKeyKekContext,
    getUserKeyKekContext,
  getUserKeyKekContextForUser,
    getRecoveryKeyKekContext,
    getMemberSigningPrivateKeyKekContext,
    getMemberSigningPublicKeyContext,
    getMemberSigningPublicKeyContextLayer2,
    getOrgPublicKeyContext,
    getOrgPublicKeyContextLayer2,
    getMemberPrivateKeyInnerKekContext,
    getOrgKeyKekAdminOrgContext,
    getOrgKeyKekMemberLockboxContext,
    getOrgPrivateKeyKekContext,
    getBackdoorPrivateKeyPartKekContext,
    getAdminPrivateKeyKekContext,
    getAdminSigningPrivateKeyKekContext,
    getGroupKeyContext,
    getGroupPrivateKeyContext,
    getGroupKeyKekContext,
    getGroupPrivateKeyKekContext,
    getGroupPublicKeyContext,
    getGroupTypeContext,
    getUserPublicKeyContext,
    getUserPrivateKeyOuterKekContext,
    getMemberPrivateKeyKekContext,
    getTransactionIdContext,
  },
  // Public key tags
  signingPublicKeyTags: SigningPublicKeyTags,
  KEY_VALIDATION_POLICY: Constants.KEY_VALIDATION_POLICY,
  SOURCE: Constants.SOURCE,
  requestSource: process.env.SOURCE,
};

// Register a private accessor (only callable by trusted code)
window.BayunCore.__grantInternalAccess = function (consumer) {
  // Check caller identity (like module ID or function signature)
  if (consumer && consumer.__isBayunAdmin) {
    consumer.__receiveInternal(internalAPI);
  }
};
